<template>
    <div class="">     
        <el-dialog
            title=""
            width="500px"
            class="repair-dialog"
            :visible.sync="dialogHide"
            :before-close="handleClose"
        >
            <div class="dialog-mains p10">
                <el-image class="img" :src="successImg"></el-image>
                <p class="money">{{ hintName ? hintName : '收银成功' }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn normal-btn" @click="gotoOrderInfo">查看订单详情</el-button>
                <el-button class="btn" type="primary" @click="gotoProductFootBath">返回主页</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import minxin from '../../assets/javascript/minxin.js'
import {decrypt,encrypt} from '../../assets/javascript/untils'
export default {
    mixins: [minxin],
    props: {
        hintName:{
            type: String,
            default: null,
        }
    },
    data () {
        return {
            form: {},
            orderId: '',
            dialogHide: false,
            headImg: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            payWayList: [],
            parentForm: {},
            isPayWayHide: true,
            successImg: require('../../assets/images/money/success.png'),
            mainHeight: this.$store.getters.MainHeight
        }
    },
    created(){
    },
    mounted(){
        this.init();
    },
    methods: {
        handleClose(){
            this.$router.push(`/collectMoney`);   
        },
        init(){
            this.$on('set',function(id){
                this.orderId = id;
                this.dialogHide = true;
            })
        },
        gotoOrderInfo(){
            this.dialogHide = false;
            this.$emit('change',this.orderId);
        },
        gotoProductFootBath(){
            this.$router.push(`/collectMoney`);   
        },
    }
}
</script>
<style>
.payway-success .el-button+.el-button{
    margin-left: 0;
}
</style>
<style scoped lang="less">
@import '../../assets/css/edit.less';
/deep/ .el-dialog{
    margin-top: 0 !important;
    height: 350px;
    top: calc(50% - 175px);
}
/deep/ .el-dialog__header {
    height: 50px;
    box-sizing: border-box;
    padding: 0;
    line-height: 50px;
    text-align: center;
    font-size: .18rem;
    .el-dialog__title{
        color: #fff;
    }
    .el-dialog__headerbtn {
        top: 13px;
        .el-dialog__close {
            color: #666;
            font-size: 0.18rem;
            border: 1px solid #666;
            border-radius: 50%;
            padding: 2px;
            &:hover{
                color: @blue;
                border: 1px solid @blue;
                background: #fff;
            }
        }
    }
}
/deep/ .el-dialog__body{
    padding: .2rem 0;
    display: flex;
    justify-content: center;
    
    .money{
        font-size: .18rem;
        color: #333;
        font-weight: bold;
        text-align: center;
    }
}

/deep/ .el-dialog__footer{
    text-align: center;
    .btn{
        font-size: .18rem;
        width: 155px;
        height: 55px;
    }
    .normal-btn{
        margin-right: 50px;
    }
}
</style>